import { initMap, equalCols } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const corporateServiceRequestLead = {
        isLoading: false,
		selectedServices: [],
        init() {
            $(document).on('click', '.corporate-service-request-show-form', this, this.show);
            $(document).on('click', '#corporate-service-request-send-btn', this, this.send);

			$(document).on('click', '#corporate-service-request .radio-line .form-check', function(){
				$('#corporate-service-request .radio-line .form-check').removeClass("selected");
				$('#corporate-service-request .radio-line .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});

			$(document).on('click', '.service-request-item', this, function(e) {
				const _this = e.data;
				let serverId = $(this).data('value');
				let cssClass = $(this).data('class');

				let activeClass = (cssClass != ''?'active-'+cssClass:'active');

				const index = _this.selectedServices.indexOf(serverId);
				if (index > -1) {
					$(this).removeClass(activeClass);
					_this.selectedServices.splice(index, 1);
				} else {
					if (_this.selectedServices.length >= 3) {
						$('#ser-notifications').html('<div class="alert alert-danger" role="alert">Poti selecta maxim 3 servicii!</div>');
						return false;
					}

					$(this).addClass(activeClass);
					_this.selectedServices.push(serverId);
				}
			});

        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let dealerId = 1*$(this).data('dealer-id');
			// if (!dealerId) {
			// 	console.log('Invalid ID!');
			// 	return false;
			// }

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('#corporate-service-request').find('.form-control').removeClass('is-invalid');
			$('#corporate-service-request').find('.form-check-input').removeClass('is-invalid');
			$('#ser-notifications').html('');


			if ($('#company').val() == '') {
				$('#company').addClass('is-invalid');
				errors = true;
			}
			if ($('#cui').val() == '') {
				$('#cui').addClass('is-invalid');
				errors = true;
			}
			if ($('#name').val() == '') {
				$('#name').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#vehicles_number option:selected').val() == '') {
				$('#vehicles_number').addClass('is-invalid');
				errors = true;
			}
			if (!$('#service-terms-and-condition').is(":checked")) {
				$('#service-terms-and-condition').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#ser-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
				document.getElementById('service-request').scrollTop = 0;
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'company=' + $('#company').val();
			values += '&cui=' + $('#cui').val();
			values += '&name=' + $('#name').val();
			values += '&email=' + $('#email').val();
			values += '&phone=' + $('#phone').val();
			values += '&vehicles_number=' + $('#vehicles_number option:selected').val();
			values += '&services=' + _this.selectedServices.join(',');
			values += '&message=' + $('#message').val();
			values += '&newsletter=' + ($('.service-request-newsletter:checked').val()?$('.service-request-newsletter:checked').val():0);
			values += '&_token=' + $('#_token_ser').val();
			$.ajax({
	            type: "POST",
	            url: corporateServiceRequestRoutePost,
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						$('#ser-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
                        return false;
                    }

					if (response.status == 1) {
						_this.selectedServices = [];
						$('#corporate-service-request').modal('hide');
						$('#corporate-service-request').on('hidden.bs.modal', function() {
							$('#corporate-service-request-container').html('');
						});

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: formSuccessMessage
						});

						if (cookies_advertisement == 1) {
							gtag('event', 'conversion', {'send_to': 'AW-732195211/BwyvCM3S1ecBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							fbq('track', 'Lead');
						}

						return false;
					}

					$('#ser-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		},
		show(event) {
			const _this = event.data;
			event.preventDefault();

			let loading = $(this).data('loading');

			if (_this.isLoading) {
                return false;
            }

			//Loading...
            _this.isLoading = true;
			let element = this;
			if(loading != '1') {
				$(element).find('i').show();
			}

			var values = '';
			$.ajax({
	            type: "GET",
	            url: corporateServiceRequestRoute,
	            data: values,
	            success: function(response) {
					if (response == 'invalid-id') {
						alert('Invalid ID!')
						return false;
					}
					_this.selectedServices = [];
					$('#corporate-service-request-container').html(response);
					$('#corporate-service-request').modal('show');

					$('#corporate-service-request').on('shown.bs.modal', function (e) {
						if ($(document).width() > 1025) {
							equalCols('.service-request-eq-height');
						}
					});

					_this.isLoading = false;
					if(loading != '1') {
						$(element).find('i').hide();
					}
	            },
                error(error) {
                    _this.isLoading = false;
					if(loading != '1') {
						$(element).find('i').hide();
					}
                },
	        });
		}
    };

    if ($('.corporate-service-request-show-form').length) {
        corporateServiceRequestLead.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/corporate-service-request-lead.js